import React from 'react';
import { NavLink } from 'react-router-dom';
import './styles.css';
function SubTabsParameters() {
  return (
    <div className="scrollable-container-app">
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <NavLink to="/parameters/params-countries" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Params Countries
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/parameters/params-currencies" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Params Currencies
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/parameters/products-packaging-pallets" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Products, Packaging & Pallets
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/parameters/kits-content" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Kits Content
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to="/parameters/containers-content" className="nav-link" activeClassName="active"
          style={{ height: "28px", fontSize: "12px", textAlign: "center" }}>
            Containers Content
          </NavLink>
        </li>
      </ul>
    </div>
  );
}

export default SubTabsParameters;
